import { FC } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

interface IProps {
  id: string | number;
}

const SnackbarAction: FC<IProps> = ({
  id,
}) => {
  const { t } = useTranslation();
  const { closeSnackbar } = useSnackbar();

  return (
    <button
      className="btn btn-sm btn-primary"
      style={{ marginRight: '10px' }}
      onClick={() => {
        closeSnackbar(id);
        sessionStorage.removeItem("snackbarKey");
      }}
    >
      {t('common.button.confirm')}
    </button>
  )
}

export default SnackbarAction;
